import React from 'react'

function Cart() {
  return (
    <div className='bg-richblack-900 h-[calc(100vh-3.5rem)] text-white'>Cart</div>
  )
}

export default Cart;